import { useMsal } from "@azure/msal-react";
import { PrimaryButton, Stack } from "@fluentui/react";
import { useEffect } from "react";
import { BrowserRouter, useRoutes } from "react-router-dom";
import { UserProvider } from "./utils/user-context";
import { loginRequest } from "./utils/auth-config";
import { appRoutes } from "./routes/app-routes";

function AppRoutes() {
  return useRoutes(appRoutes);
}

export default function App() {
  const { instance, accounts } = useMsal();
  const path = window.location.pathname;
  const isDemoRoute = path.startsWith("/demo");

  useEffect(() => {
    if (!isDemoRoute) {
      const current = instance.getActiveAccount();
      if (!current && accounts.length > 0) {
        instance.setActiveAccount(accounts[0]);
      }
    }
  }, [accounts, instance, isDemoRoute]);

  const login = () => {
    instance.loginRedirect(loginRequest);
  };

  const isLoggedIn = accounts.length > 0;

  return (
    <Stack>
      <BrowserRouter>
        {isDemoRoute ? (
          // Demo → no login needed
          <AppRoutes />
        ) : isLoggedIn ? (
          // Normal flow → must login
          <UserProvider>
            <AppRoutes />
          </UserProvider>
        ) : (
          <div className="loginButton">
            <PrimaryButton text="Login with Microsoft" onClick={login} />
          </div>
        )}
      </BrowserRouter>
    </Stack>
  );
}
